import { create } from 'zustand';
import type { ChiTieuChildMismatchWarning } from '@/types/performance/Target/ChiTieuChildWarning';
import { parseChiTieuChildWarningPayload } from '@/components/MeasureIndicators/helpers/buoc6ChiTieuChildWarning';

type Buoc6ChiTieuWarningHeaderState = {
  departmentId: string;
  warnings: ChiTieuChildMismatchWarning[];
  activeWarnings: ChiTieuChildMismatchWarning[];
  loading: boolean;
  syncedAt: number;
  setLoading: (loading: boolean) => void;
  beginFetch: (departmentId: string) => void;
  setFromPage: (departmentId: string, payload: unknown) => void;
  setFromFetch: (departmentId: string, payload: unknown) => void;
  clear: () => void;
};

function toActiveWarnings(items: ChiTieuChildMismatchWarning[]) {
  return items.filter((w) => !w.isDismissed);
}

export const useBuoc6ChiTieuWarningHeaderStore = create<Buoc6ChiTieuWarningHeaderState>((set) => ({
  departmentId: '',
  warnings: [],
  activeWarnings: [],
  loading: false,
  syncedAt: 0,

  setLoading: (loading) => set({ loading }),

  beginFetch: (departmentId) =>
    set({
      departmentId,
      warnings: [],
      activeWarnings: [],
      loading: true,
      syncedAt: 0,
    }),

  setFromPage: (departmentId, payload) => {
    const parsed = parseChiTieuChildWarningPayload(payload);
    set({
      departmentId,
      warnings: parsed.items,
      activeWarnings: toActiveWarnings(parsed.items),
      loading: false,
      syncedAt: Date.now(),
    });
  },

  setFromFetch: (departmentId, payload) => {
    const parsed = parseChiTieuChildWarningPayload(payload);
    set({
      departmentId,
      warnings: parsed.items,
      activeWarnings: toActiveWarnings(parsed.items),
      loading: false,
      syncedAt: Date.now(),
    });
  },

  clear: () =>
    set({
      departmentId: '',
      warnings: [],
      activeWarnings: [],
      loading: false,
      syncedAt: 0,
    }),
}));
